import c from '../Assets/Images/skills/c.svg';
import cpp from '../Assets/Images/skills/cplusplus.svg';
import rust from '../Assets/Images/skills/rust.svg';
import ros from '../Assets/Images/skills/ros.svg';
import go from '../Assets/Images/skills/go.svg';
import java from '../Assets/Images/skills/java.svg';
import kotlin from '../Assets/Images/skills/kotlin.svg';
import typescript from '../Assets/Images/skills/typescript.svg';
import docker from '../Assets/Images/skills/docker.svg';
import kubernetes from '../Assets/Images/skills/kubernetes.svg';
import git from '../Assets/Images/skills/git.svg';
import datadog from '../Assets/Images/skills/datadog.svg';
import python from '../Assets/Images/skills/python.svg';
import pytorch from '../Assets/Images/skills/pytorch.svg';
import spark from '../Assets/Images/skills/apachespark.svg';
import sklearn from '../Assets/Images/skills/scikitlearn.svg';

// Visual groupings of the existing skills; the examples illustrate each area,
// rather than asserting that every listed tool was used at the linked employer.
export const skillGroups = [
  {
    id: 'systems', title: 'Systems & robotics', description: 'Closer to the hardware.',
    featured: [{ name: 'C', icon: c }, { name: 'C++', icon: cpp }, { name: 'Rust', icon: rust, monochrome: true }, { name: 'ROS2', icon: ros, monochrome: true }],
    supporting: ['OpenCV', 'OpenVX', 'Valgrind', 'Gcov'],
    proof: 'I worked on fleet interoperability across 500+ robots and rebuilt robot tracking around ROS2 events.',
    example: 'Fleet Core at OTTO', link: '/career#otto',
  },
  {
    id: 'backend', title: 'Backend & distributed systems', description: 'Services, queues, and the data between them.',
    featured: [{ name: 'Java', icon: java, lightPlate: true }, { name: 'Go', icon: go }, { name: 'Kotlin', icon: kotlin }, { name: 'TypeScript', icon: typescript }],
    supporting: ['Redis', 'Python', 'Scala', 'FastAPI', 'DynamoDB', 'SQS'],
    proof: "I'm using Java at AWS to build a dynamic rate limiter for the Journal Service Control Plane.",
    example: 'My work at AWS', link: '/career#aws',
  },
  {
    id: 'infrastructure', title: 'Infrastructure & observability', description: 'Shipping it, then figuring out what broke.',
    featured: [{ name: 'Docker', icon: docker }, { name: 'Kubernetes', icon: kubernetes }, { name: 'Git', icon: git }, { name: 'Datadog', icon: datadog, lightPlate: true }],
    supporting: ['Jenkins', 'Bash', 'Splunk'],
    proof: 'I introduced production debugging workflows that reduced mean time to resolution by 50%.',
    example: 'Incident response at Super.com', link: '/career#super',
  },
  {
    id: 'data', title: 'Data & machine learning', description: 'Models, experiments, and privacy.',
    featured: [{ name: 'Python', icon: python }, { name: 'PyTorch', icon: pytorch }, { name: 'Spark', icon: spark }, { name: 'scikit-learn', icon: sklearn, lightPlate: true }],
    supporting: ['SQL', 'Pandas', 'NumPy'],
    proof: 'I tested membership inference attacks against diffusion-generated synthetic tabular data.',
    example: 'Research with Waterloo & Vector', link: '/career#vector-research',
  },
];
